import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FaCar, FaInfoCircle, FaPlus } from 'react-icons/fa';
import { deleteBookingShuttle, removeShuttleDocument } from 'redux/booking/travel/travelBookingSlice';
import { Button, Tabs, Confirmation, Drawer } from 'components/common';
import TransactionForm from 'components/app/bookings/car/transaction/TransactionForm';
import ShuttleForm from './ShuttleForm';
import ShuttleItem from './ShuttletIem';
import BookingTable from './BookingTable';

const shuttleIcon = (name) => {
  switch (name) {
    case 'Plane': return 'plane';
    case 'Train': return 'train';
    case 'Taxi': return 'taxi';
    default: return 'car';
  }
};

const ShuttleList = ({ booking }) => {
  const [showModalShuttle, setshowModalShuttle] = useState(false);
  const [showConfirmationDelete, setShowConfirmationDelete] = useState(false);
  const [showCarDrawer, setShowCarDrawer] = useState(false);
  const [shuttle, setShuttle] = useState(null);
  const { shuttles } = booking;

  const bookingId = booking.id;
  const dispatch = useDispatch();

  const handleEditShuttleBooking = (s) => { setShuttle(s); setshowModalShuttle(true); };
  const handleCreateShuttleBooking = () => { setShuttle(null); setshowModalShuttle(true); };
  const handleDeleteShuttleBooking = (s) => { setShuttle(s); setShowConfirmationDelete(true); };
  const handleRemoveAttachment = (shuttleId, documentId) => dispatch(removeShuttleDocument({ bookingId, shuttleId, documentId }));
  const handleMakeCarBooking = () => setShowCarDrawer(true);

  const handleOkConfirm = () => {
    dispatch(deleteBookingShuttle({ bookingId, shuttleId: shuttle.id }));
    setShowConfirmationDelete(false);
  };

  const shuttlesWithoutOthers = (shuttles || []).filter((s) => s.other === false);

  const overviewTab = (
    <div className="tw-pt-3">
      {shuttlesWithoutOthers.map((s) => (
        <ShuttleItem
          key={s.id}
          booking={booking}
          shuttle={s}
          icon={shuttleIcon(s.name)}
          editShuttleBooking={() => handleEditShuttleBooking(s)}
          deleteShuttleBooking={() => handleDeleteShuttleBooking(s)}
          handleRemoveAttachment={handleRemoveAttachment}
        />
      ))}
    </div>
  );

  return (
    <>
      <div className="tw-flex tw-justify-end tw-gap-2 tw-mb-3">
        <Button size="sm" variant="secondary" leftIcon={FaPlus} onClick={handleCreateShuttleBooking}>New Shuttle Booking</Button>
        <Button size="sm" variant="secondary" leftIcon={FaCar} onClick={handleMakeCarBooking}>Make Car Booking</Button>
      </div>

      <Tabs
        variant="underline"
        tabs={[
          { label: 'Overview', icon: <FaInfoCircle size={12} />, content: overviewTab },
          { label: 'Car booking', icon: <FaCar size={12} />, content: <div className="tw-pt-3"><BookingTable data={booking?.car_bookings} /></div> },
        ]}
      />

      <ShuttleForm showModal={showModalShuttle} setshowModal={setshowModalShuttle} booking={booking} shuttle={shuttle} />

      <Drawer
        show={showCarDrawer}
        onHide={() => setShowCarDrawer(false)}
        title={<><FaCar className="tw-text-blue-600" /> Request car booking</>}
        width="55%"
      >
        <TransactionForm
          embedded
          title="Request car booking"
          travel={booking}
          onClose={() => setShowCarDrawer(false)}
          onSuccess={() => setShowCarDrawer(false)}
        />
      </Drawer>

      <Confirmation
        show={showConfirmationDelete}
        type="danger"
        title="Delete shuttle"
        message="Are you sure to delete?"
        confirmText="Delete"
        onConfirm={handleOkConfirm}
        onCancel={() => setShowConfirmationDelete(false)}
      />
    </>
  );
};

ShuttleList.propTypes = {
  booking: PropTypes.object.isRequired,
};

export default ShuttleList;
